export const globalParameters = {
  verType: 'standalone'
  // verType: 'platform'
}
